"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGPracticeScene = void 0;
const CTGMenuScene_1 = require("../CTGMenuScene");
const CTGGameModes_1 = require("../CTGGameModes");
class CTGPracticeScene extends CTGMenuScene_1.CTGMenuScene {
    constructor() {
        super("CTGPracticeScene");
    }
    onCreate() {
        super.onCreate();
        this.setTitle("Practice");
        let sorted_game_modes = [...CTGGameModes_1.game_modes];
        sorted_game_modes.sort((a, b) => a.title.localeCompare(b.title));
        for (const game_mode of sorted_game_modes) {
            this.addOption(game_mode.title, null, () => {
                this.startScene('CTGGameInfoScene', { game_modes: [game_mode] });
            });
        }
    }
}
exports.CTGPracticeScene = CTGPracticeScene;
